import { z } from 'zod';

export const StatesSchema = z.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']);

export type States = z.infer<typeof StatesSchema>;
